import {  RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

export const routes: Routes = [
  /*{
    path: 'employee',
    loadChildren: () => import('./employee/employee.module')
      .then(m => m.EmployeeModule),
  },*/
  {
    path: 'identity',
    loadChildren: () => import('./identity/identity.module')
      .then(m => m.IdentityModule),
  },
  { path: '', redirectTo: 'identity', pathMatch: 'full' },
  { path: '**', redirectTo: 'identity' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AgtRoutingModule {
}
